import { render, staticRenderFns } from "./m-modal-size-guide.vue?vue&type=template&id=3c4be5ef&scoped=true&"
import script from "./m-modal-size-guide.vue?vue&type=script&lang=js&"
export * from "./m-modal-size-guide.vue?vue&type=script&lang=js&"
import style0 from "./m-modal-size-guide.vue?vue&type=style&index=0&id=3c4be5ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4be5ef",
  null
  
)

export default component.exports